import { FUNCTIONALITIES_ENDPOINTS } from '@app/configs/api/functionalities';
import { baseApi } from './baseApi';
import { TAG_TYPES } from './tagTypes';
export const functionalitiesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFunctionalities: builder.query({
            query: () => ({ url: FUNCTIONALITIES_ENDPOINTS.functionalities }),
            transformResponse: (response) => response.reduce((acc, functionality) => {
                acc[functionality.name] = functionality;
                return acc;
            }, {}),
            providesTags: [TAG_TYPES.FUNCTIONALITIES],
        }),
    }),
    overrideExisting: false,
});
export const { useGetFunctionalitiesQuery, useLazyGetFunctionalitiesQuery } = functionalitiesApi;
